import React, { useState } from 'react';
import { MKFCodeItemProps } from './types';
import { PlusIcon, MinusIcon, FolderIcon } from './icons';
import styles from './mkf-code-item.module.scss';

export const MKFCodeItem: React.FC<MKFCodeItemProps> = ({ 
	item, 
	level, 
	onSelect, 
	selectedCode 
}) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const hasChildren = item.codes && item.codes.length > 0;
	const isSelected = selectedCode === item.code;
	const isTerminal = !hasChildren;

	const handleClick = () => {
		if (isTerminal) {
			onSelect(item.code, item.name);
		} else {
			setIsExpanded(!isExpanded);
		}
	};

    const handleSelect = (code: string, name?: string) => {
        onSelect(code, name);
    };

	return (
		<div className={styles.item}>
			<div 
				className={`${styles.itemContent} ${isSelected ? styles.selected : ''} ${isTerminal ? styles.terminal : ''}`}
				style={{ paddingLeft: `${level * 20}px` }}
				onClick={handleClick}
			>
				{hasChildren && (
					<span className={styles.expandIcon}>
						{isExpanded ? <MinusIcon /> : <PlusIcon />}
					</span>
				)}
				<span className={styles.folderIcon}>
					<FolderIcon />
				</span>
				<span className={styles.code}>{item.code}</span>
				<span className={styles.name}>{item.name}</span>
			</div>
			
			{hasChildren && isExpanded && (
				<div className={styles.children}>
					{item.codes.map((child) => (
						<MKFCodeItem
							key={child.code}
							item={child}
							level={level + 1}
							onSelect={handleSelect}
							selectedCode={selectedCode}
						/>
					))}
				</div>
			)}
		</div>
	);
};
